module.exports = __webpack_public_path__ + "media/images/plans/schedule_4-1cbda2fe5edddc9d553f4f06f260bfd4.jpg";